import type { ChecklistDocument } from '@midscene/test/checklist';

export type UserRole = 'admin' | 'member';
export type TaskPlatform = 'android' | 'ios';
export type TaskInputType = 'text' | 'docx';
export type RunStatus =
  | 'claimed'
  | 'preparing'
  | 'running'
  | 'finished'
  | 'interrupted';
export type TestResult = 'passed' | 'failed';
export type UploadStatus = 'pending' | 'uploading' | 'uploaded' | 'failed';

export interface PublicUser {
  id: string;
  username: string;
  role: UserRole;
}

export interface SessionResponse {
  token: string;
  user: PublicUser;
}

export interface ProjectSummary {
  id: string;
  name: string;
  createdAt: string;
}

export interface TaskSummary {
  id: string;
  projectId: string;
  title: string;
  platform: TaskPlatform;
  inputType: TaskInputType;
  createdBy: string;
  createdByName?: string;
  createdAt: string;
  hasChecklist: boolean;
  currentRun: RunSummary | null;
}

export interface ChecklistState {
  checklist: ChecklistDocument | null;
  yaml: string | null;
  checklistRevision: number;
}

export const isActiveRun = (status: RunStatus | undefined): boolean =>
  status === 'claimed' || status === 'preparing' || status === 'running';

export interface TaskDetail extends TaskSummary, ChecklistState {
  sourceText: string;
  docxRelativePath?: string | null;
  projectName?: string;
  runs: RunSummary[];
}

export interface RunSummary {
  id: string;
  taskId: string;
  claimedBy: string;
  claimedByName?: string;
  claimedAt: string;
  deviceLabel: string;
  status: RunStatus;
  result: TestResult | null;
  uploadStatus: UploadStatus;
  startedAt: string | null;
  endedAt: string | null;
  summary: RunResultSummary | null;
  error: string | null;
}

export interface RunResultSummary {
  passed: number;
  failed: number;
  notRun: number;
  reportPath?: string;
}

export interface ReportFilePayload {
  path: string;
  sha256: string;
  contentBase64: string;
}
